import { Link } from 'foundations-components/transitional/components/Link';
import { stopPropagationHandler } from 'foundations-components/transitional/utils/DomEvents';
import { memo } from 'react';
import { linkify } from '../../utils/linkify';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function AutolinkedText({
  text
}) {
  const linkifierResult = linkify(text);

  // Splits text into an array of alternating plain text and linked segments based on matched links.
  // Offset marks the start of a link in the original text, so we use that along with a pointer to the last
  // processed character's index to determine how far to slice.
  const elements = [];
  let lastIndex = 0;
  for (const {
    matchedText,
    href,
    target,
    offset
  } of linkifierResult) {
    if (offset > lastIndex) {
      elements.push(text.substring(lastIndex, offset));
    }
    elements.push( /*#__PURE__*/_jsx(Link, {
      external: true,
      href: href,
      target: target,
      onClick: stopPropagationHandler,
      children: matchedText
    }, `${matchedText}-${offset}`));
    lastIndex = offset + matchedText.length;
  }
  if (lastIndex < text.length) {
    elements.push(text.substring(lastIndex));
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: elements
  });
}
export default /*#__PURE__*/memo(AutolinkedText);